import { Row, TableBodyPropGetter, TableBodyProps } from 'react-table';
import { useTranslation } from 'react-i18next';

import { RowColor } from 'types';

import { Headline } from 'components/Headline';

import * as S from './Body.styles';

type BodyProps = {
  data: readonly {}[];
  getTableBodyProps: (propGetter?: TableBodyPropGetter<{}> | undefined) => TableBodyProps;
  rows: Row<{}>[];
  prepareRow: (row: Row<{}>) => void;
  renderRowColor?: (row: Row) => RowColor;
  onRowClick?: (row: Row) => void;
  columnsCount: number;
};

const defaultProps: Partial<BodyProps> = {};

export function Body(props: BodyProps): React.ReactElement {
  const { t } = useTranslation();

  const {
    data,
    getTableBodyProps,
    rows,
    prepareRow,
    renderRowColor,
    onRowClick,
    columnsCount,
  } = {
    ...defaultProps,
    ...props,
  };

  return (
    <S.Body {...getTableBodyProps()}>
      {data && data.length > 0 ? (
        rows.map((row) => {
          prepareRow(row);

          return (
            <S.TR
              {...row.getRowProps()}
              key={row.getRowProps().key}
              colors={renderRowColor ? renderRowColor(row) : null}
              isRowBold={row.values.status === 'ABANDONED'}
              isClickable={!!onRowClick}
              onClick={() => onRowClick?.(row)}
            >
              {row.cells.map((cell) => (
                <S.TD {...cell.getCellProps()} key={cell.getCellProps().key}>
                  {cell.render('Cell')}
                </S.TD>
              ))}
            </S.TR>
          );
        })
      ) : (
        <S.TR>
          <S.TD hasNoData colSpan={columnsCount}>
            <S.NoData>
              <Headline textAlign="center" scale="xl">
                {t('common.noData')}
              </Headline>
            </S.NoData>
          </S.TD>
        </S.TR>
      )}
    </S.Body>
  );
}
